// /var/www/afra/web-design.rampagesoft.com/my-app/src/component/HomeBusiness.js
import React from 'react';
import '../css/HomeBusiness.scss';
import ExamplesSlider from './ExamplesSlider';
import homeBusinessData from '../data/HomeBusiness.json';

const HomeBusiness = ({ Swiper, SwiperSlide, swiperConfig }) => {
  const colorMap = {
    'primary-red': 'primary-red',
    'primary-blue': 'primary-blue',
    'primary-purple': 'primary-purple'
  };

  return (
    <>
      {homeBusinessData.map(section => {
        const {
          id,
          name,
          color,
          heading,
          subheading,
          suitable,
          benefits,
          additionalServices,
          processSteps,
          processList,
          examplesHeading
        } = section;

        const sectionColor = colorMap[color] || 'primary-red';

        return (
          <section
            key={id}
            id={name}
            className={`business-section ${sectionColor}`}
          >
            <div className="business-left">
              <h2
                className="business-heading"
                dangerouslySetInnerHTML={{ __html: heading.text }}
              />
              <p className="business-subheading">{subheading.text}</p>
              <div className="business-suitable">
                {suitable.map(item => (
                  <div className="suitable-item" key={item.id}>
                    <span className="suitable-circle">
                      <i className={`${item.icon} step-icon`}></i>
                    </span>
                    <span>{item.text}</span>
                  </div>
                ))}
              </div>

              <h3 className="benefits-title">{benefits.title.text}</h3>
              <ul className="benefits-list">
                {benefits.items.map(item => (
                  <li key={item.id}>{item.text}</li>
                ))}
              </ul>

              <h3 className="benefits-title">{additionalServices.title.text}</h3>
              <div className="benefits-grid">
                {additionalServices.items.map(item => (
                  <div className="benefits-grid-item" key={item.id}>
                    <i className={`${item.icon} grid-icon`}></i>
                    <p>{item.text}</p>
                  </div>
                ))}
              </div>

              <a href={benefits.title.link} className="primary-button">{benefits.title.contact}</a>
            </div>

            <div className="business-right">
              <h3 className="process-heading">{processSteps.title.text}</h3>
              <div className="process-steps">
                {processSteps.items.map(step => (
                  <div className="process-item" key={step.id}>
                    <div className="step-wrapper">
                      <span className="step-badge">{step.badge}</span>
                      <span className="step-circle">
                        <i className={`${step.icon} step-icon`}></i>
                      </span>
                    </div>
                    <p>{step.text}</p>
                  </div>
                ))}
              </div>

              <ul className="process-list">
                {processList.map(item => (
                  <li key={item.id}>{item.text}</li>
                ))}
              </ul>

              <h4 className="examples-heading">{examplesHeading.text}</h4>
              <ExamplesSlider
                Swiper={Swiper}
                SwiperSlide={SwiperSlide}
                swiperConfig={swiperConfig}
                sectionId={id}
              />
            </div>
          </section>
        );
      })}
    </>
  );
};

export default HomeBusiness;